<script setup lang="ts">
import { AppLogo, AppTypography } from '@/components';
import { useDebounceFn } from '@vueuse/core';

const { isLink = true } = defineProps<{ isLink?: boolean }>();

const count = useState('counter', () => Math.round(Math.random() * 1000));

const homeClick = useDebounceFn(() => {
  count.value = Math.round(Math.random() * 1000);
}, 200);
</script>

<template>
  <v-app-bar-title>
    <template #text class="d-flex">
      <nuxt-link v-if="isLink" to="/" @click="homeClick" class="d-inline-flex ga-2 align-center text-decoration-none">
        <AppLogo :width="32" :height="32" />
        <AppTypography type="title-3" color="primary">Tradel</AppTypography>
      </nuxt-link>
      <div v-else class="d-inline-flex ga-2 align-center">
        <AppLogo :width="32" :height="32" />
        <AppTypography type="title-3" color="primary">Tradel</AppTypography>
      </div>
    </template>
  </v-app-bar-title>
</template>

<style lang="scss" scoped>
.v-toolbar-title {
  margin-inline-start: 0px !important;
  flex: none;
  width: 137px;

  @media (max-width: 768px) {
    width: unset;
  }
}

:deep(.v-toolbar-title__placeholder) {
  display: flex !important;
}
</style>
